import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import type { DealTabs } from '@makemydeal/dr-shared-types';

import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';
import { useMaxResidualizedMsrpField } from './hooks/useMaxResidualizedMsrpField';
import MaxResidualizedMsrpAppliedField from './MaxResidualizedMsrpAppliedField.interstate';

const MaxResidualizedMsrpField = ({ tab }: { tab?: DealTabs }) => {
    const { label, overrideIndicatorProps, inputProps } = useMaxResidualizedMsrpField({ tab });

    return (
        <FieldOverrideIndicator {...overrideIndicatorProps}>
            <NumericInput label={label} {...inputProps} />
            <MaxResidualizedMsrpAppliedField />
        </FieldOverrideIndicator>
    );
};

export default MaxResidualizedMsrpField;
